React = require 'react'
t = require('views/internal/recup-with-helpers')('org_members')
_ = require 'underscore'

module.exports = class OrganizationMembersListComponent extends React.Component

  render: t.renderable ->
    { memberItems,
      showNewLayout,
      memberTypeFilter
    } = @props

    visibleMembers = _.filter(memberItems, (item) => item.props.isFilterMatch)

    # EXPERIMENT: teamMembersTabLayoutV1
    if showNewLayout
      if !memberItems.length
        t.div -> return
      else if !visibleMembers.length
        t.div ->
          t.div '.org-members-missing-container', ->
            t.img
              className: 'org-members-missing-illustration'
              alt: t.l 'no-guest-result'
              src: require('images/organization/missing.svg')
            t.div '.org-members-missing-content', ->
              if memberTypeFilter is 'guest'
                t.p -> t.format 'no-guest-result'
              else
                t.p -> t.format 'no-member-result'
      else
        t.div ->
          memberItems.forEach(t.addElement)
          return
    else
      t.div ->
        memberItems.forEach(t.addElement)
        return



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-members-list-component.coffee